import {NgModule} from '@angular/core';
import {LoginComponent} from './login.component';
import {LogoutComponent} from './logout/logout.component';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AppCommonModule} from '../../common/common.module';
import {MaterialModule} from '../../material/material.module';
import {LoginRoutingModule} from './login-routing.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    LoginComponent,
    LogoutComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    AppCommonModule,
    MaterialModule,
    ReactiveFormsModule,
    LoginRoutingModule,
    TranslateModule
  ]
})
export class LoginModule { }
